module.exports = __webpack_public_path__ + "3aea45781626c6659fea2257b36d58da.svg";